<template>
    <section class="notenausgabe-sv">
        <FormGroupBuilder :fields="currentIoFields" :data="data" :refresh="validationRefresh" />
        <NotenartausgabeSV :id="data.noten_id" :notentyp="notentyp" @update="changedValues" />
    </section>
</template>

<script>
import Validation from "@/mixins/Validation/Validation";
import Toaster from "@/mixins/Toaster/Toaster";
import { ApiFactory } from "@/api/ApiFactory.js";
import FormGroupBuilder from "@/components/FormGroupBuilder/FormGroupBuilder";
import NotenartausgabeSV from "@/components/Notentransfer/NotenartausgabeSV/NotenartausgabeSV";

const WerkeApi = ApiFactory.get("werke");
const NotenverwaltungApi = ApiFactory.get("notenverwaltung");
const MitgliederApi = ApiFactory.get("mitglieder");

export default {
    name: "NotenausgabeSV",
    mixins: [Validation, Toaster],
    components: {
        FormGroupBuilder,
        NotenartausgabeSV
    },
    props: ["svId", "werkId", "notenId", "notentyp", "validationData"],
    data() {
        return {
            ioFields: {
                single: {
                    werk_id: {
                        key: "werk_id",
                        label: "Konzert",
                        type: "filteredselect",
                        api: WerkeApi,
                        rels: {
                            key: "id",
                            value: item => {
                                return (
                                    item.bezeichnung +
                                    " (" +
                                    this.$moment(item.verfallsdatum).format(
                                        "DD.MM.Y"
                                    ) +
                                    ")"
                                );
                            }
                        },
                        mandatory: true
                    },
                    noten_id: {
                        key: "noten_id",
                        label: "Noten",
                        type: "filteredselect",
                        api: NotenverwaltungApi,
                        rels: {
                            key: "id",
                            value: item => {
                                return (
                                    item.komponist +
                                    ": " +
                                    item.werk +
                                    (item.ausgabe
                                        ? " (" + item.ausgabe + ")"
                                        : "")
                                );
                            }
                        },
                        mandatory: true
                    },
                    sv_id: {
                        key: "sv_id",
                        label: "Stimmvertreter",
                        type: "select",
                        options: [
                            {
                                text: "Stimmvertreter auswählen...",
                                value: null
                            }
                        ],
                        mandatory: true,
                        disabled: true
                    },
                    hr: {
                        key: "hr",
                        type: "hr"
                    }
                },
                multiple: {
                    werk_id: {
                        key: "werk_id",
                        label: "Konzert",
                        type: "filteredselect",
                        api: WerkeApi,
                        rels: {
                            key: "id",
                            value: item => {
                                return (
                                    item.bezeichnung +
                                    " (" +
                                    this.$moment(item.verfallsdatum).format(
                                        "DD.MM.Y"
                                    ) +
                                    ")"
                                );
                            }
                        },
                        mandatory: true
                    },
                    noten_id: {
                        key: "noten_id",
                        label: "Noten",
                        type: "filteredselect",
                        api: NotenverwaltungApi,
                        rels: {
                            key: "id",
                            value: item => {
                                return (
                                    item.komponist +
                                    ": " +
                                    item.werk +
                                    (item.ausgabe
                                        ? " (" + item.ausgabe + ")"
                                        : "")
                                );
                            }
                        },
                        mandatory: true
                    },
                    sv_id: {
                        key: "sv_id",
                        label: "Stimmvertreter",
                        type: "checkboxselect",
                        options: [],
                        busy: true,
                        mandatory: true,
                        disabled: true
                    },
                    hr: {
                        key: "hr",
                        type: "hr"
                    }
                }
            },
            data: {
                werk_id: this.werkId,
                noten_id: this.notenId,
                sv_id: this.svId || (this.isSingle ? null : []),
                issued: {}
            },
            sv: []
        };
    },
    computed: {
        isSingle() {
            return this.werkId;
        },
        currentIoFields() {
            if (this.isSingle) {
                return this.ioFields.single;
            } else {
                return this.ioFields.multiple;
            }
        }
    },
    created() {
        this.fetchSV();
    },
    watch: {
        data: {
            handler(val) {
                this.cleanValidationData(this.currentIoFields);
                this.$emit("update", val);
            },
            deep: true
        },
        "data.noten_id": {
            handler() {
                this.dataSet();
            }
        },
        validationData: {
            handler(val) {
                this.cleanValidationData(this.currentIoFields);
                if (typeof val.json.validation === "object") {
                    this.handleValidationData(val, this.currentIoFields);
                } else {
                    this.makeToast(
                        "Fehler beim Speichern der Transaktion",
                        val.json.validation,
                        "danger"
                    );
                }
            }
        }
    },
    methods: {
        async fetchSV() {
            this.currentIoFields.sv_id.disabled = true;
            this.currentIoFields.sv_id.busy = true;
            const response = await MitgliederApi.get({
                fields: "id,vorname,name",
                filter_statuserweiterung: 139
            });
            if (response.ok) {
                const sv = response.json.collection;
                sv.forEach(item => {
                    this.currentIoFields.sv_id.options.push({
                        value: item.id,
                        text: item.vorname + " " + item.name
                    });
                });
                this.sv = sv;
            }
            this.currentIoFields.sv_id.disabled = false;
            this.currentIoFields.sv_id.busy = false;
        },
        changedValues(issueObj) {
            this.data.issued[issueObj.id] = issueObj;
            this.$emit("update", this.data);
        },
        dataSet() {
            this.data.issued = {};
        }
    }
};
</script>